
import React from "react";
import { CheckCircle2 } from "lucide-react";

export function WelcomeStep() {
  return (
    <div className="space-y-4">
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle2 className="h-8 w-8 text-primary" />
        </div>
      </div>
      
      <h2 className="text-xl font-semibold text-center">Welcome to ContractFlow</h2>
      
      <p className="text-center text-muted-foreground">
        This setup guide will help you configure your account with all the essential settings.
      </p>
      
      <div className="bg-muted p-4 rounded-lg mt-6">
        <h3 className="font-medium mb-2">What we'll cover:</h3>
        <ul className="space-y-2 ml-6 list-disc">
          <li>Setting up contract categories to organize your contracts</li>
          <li>Creating contract types to standardize your workflow</li>
          <li>Configuring currencies and exchange rate providers</li>
          <li>Connecting to company registers for easy company data lookup</li>
          <li>Customizing importance color settings for visual prioritization</li>
        </ul>
      </div>
      
      <p className="mt-6">
        You can complete this setup now, or you can access it later from the Settings page.
        Let's get started!
      </p>
    </div>
  );
}
